<template>
  <NavBar v-if="isLoggedIn">
  <!-- If user is logged in, show the normal navbar with burger menu -->
  </NavBar>
  <div v-else class="bg-[#022239] w-full">
    <!-- Custom header for logged out users -->
    <div class="flex justify-between items-center px-4 py-6">
      <img src="../../../assets/bowsys.png" class="w-32" alt="" />
      <router-link to="/pages/login" class="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md transition">
        Log In
      </router-link>
    </div>
  </div>

  <!-- Тэргүүлэх хэсэг -->
  <section class="bg-gradient-to-r from-blue-50 to-gray-50 py-20">
    <div class="container mx-auto px-6 flex flex-col md:flex-row items-center">
      <div class="md:w-1/2 mb-10 md:mb-0">
        <h1 class="text-4xl md:text-5xl font-bold text-gray-800 leading-tight mb-4">Ирээдүйн таньд зориулсан ухаалаг санхүүгийн шийдлүүд</h1>
        <p class="text-lg text-gray-600 mb-8">Бид таны хөрөнгө өсгөх, тэтгэвэрт бэлтгэх, санхүүгийн ирээдүйгээ баталгаажуулах мэргэжлийн санхүүгийн үйлчилгээг санал болгож байна.</p>
        <div class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
          <button class="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition">Үнэгүй зөвлөгөө авах</button>
          <button class="px-6 py-3 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-50 transition">
            <i class="fas fa-play-circle mr-2"></i> Видео үзэх
          </button>
        </div>
      </div>
      <div class="md:w-1/2">
        <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Санхүүгийн төлөвлөлт" class="rounded-lg shadow-xl">
      </div>
    </div>
  </section>

  <!-- Статистик хэсэг -->
  <section class="py-16 bg-white">
    <div class="container mx-auto px-6">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
        <div class="p-6 border border-gray-200 rounded-lg hover:shadow-md transition">
          <div class="text-4xl font-bold text-blue-600 mb-2">25+</div>
          <div class="text-gray-600">Жилийн туршлага</div>
        </div>
        <div class="p-6 border border-gray-200 rounded-lg hover:shadow-md transition">
          <div class="text-4xl font-bold text-blue-600 mb-2">10K+</div>
          <div class="text-gray-600">Сэтгэл хангалуун үйлчлүүлэгч</div>
        </div>
        <div class="p-6 border border-gray-200 rounded-lg hover:shadow-md transition">
          <div class="text-4xl font-bold text-blue-600 mb-2">$5B+</div>
          <div class="text-gray-600">Удирдсан хөрөнгө</div>
        </div>
      </div>
    </div>
  </section>

  <!-- Үйлчилгээний хэсэг -->
  <section class="py-20 bg-gray-50">
    <div class="container mx-auto px-6">
      <div class="text-center mb-16">
        <h2 class="text-3xl font-bold text-gray-800 mb-4">Манай санхүүгийн үйлчилгээнүүд</h2>
        <p class="text-gray-600 max-w-2xl mx-auto">Бид таны хувийн хэрэгцээ, зорилгод тохирсон цогц санхүүгийн шийдлүүдийг санал болгож байна.</p>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div v-for="service in services" :key="service.title" class="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition">
          <div class="text-blue-600 text-4xl mb-4">
            <i :class="service.icon"></i>
          </div>
          <h3 class="text-xl font-bold text-gray-800 mb-3">{{ service.title }}</h3>
          <p class="text-gray-600 mb-4">{{ service.description }}</p>
          <a href="#" class="text-blue-600 hover:text-blue-800 font-medium">Дэлгэрэнгүй →</a>
        </div>
      </div>
    </div>
  </section>

  <!-- Үйлчлүүлэгчдийн сэтгэгдэл -->
  <section class="py-20 bg-white">
    <div class="container mx-auto px-6">
      <div class="text-center mb-16">
        <h2 class="text-3xl font-bold text-gray-800 mb-4">Үйлчлүүлэгчдийн сэтгэгдэл</h2>
        <p class="text-gray-600 max-w-2xl mx-auto">Зөвхөн бидний үг биш - манай сэтгэл хангалуун үйлчлүүлэгчдийн үгс.</p>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div v-for="testimonial in testimonials" :key="testimonial.name" class="bg-gray-50 p-8 rounded-lg">
          <div class="flex items-center mb-4">
            <div class="text-yellow-400 mr-2" v-for="star in 5" :key="star">
              <i class="fas fa-star"></i>
            </div>
          </div>
          <p class="text-gray-600 italic mb-6">"{{ testimonial.comment }}"</p>
          <div class="flex items-center">
            <img :src="testimonial.avatar" alt="Үйлчлүүлэгч" class="w-12 h-12 rounded-full mr-4">
            <div>
              <h4 class="font-bold text-gray-800">{{ testimonial.name }}</h4>
              <p class="text-gray-600 text-sm">{{ testimonial.position }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA хэсэг -->
  <section class="py-20 bg-blue-600 text-white">
    <div class="container mx-auto px-6 text-center">
      <h2 class="text-3xl font-bold mb-6">Санхүүгийн ирээдүйгээ удирдахад бэлэн үү?</h2>
      <p class="text-xl mb-8 max-w-2xl mx-auto">Өнөөдөр манай санхүүгийн мэргэжилтнүүдтэй үнэгүй зөвлөлдөх цаг захиалаарай.</p>
      <button class="px-8 py-3 bg-white text-blue-600 rounded-md font-bold hover:bg-gray-100 transition">Яг одоо эхлэх</button>
    </div>
  </section>

  <!-- Хөл -->
  <footer class="bg-gray-900 text-white py-12">
    <div class="container mx-auto px-6">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h3 class="text-2xl font-bold mb-4">Prime<span class="text-blue-400">Finance</span></h3>
          <p class="text-gray-400">25-аас дээш жилийн турш таны хөрөнгийг бий болгох, хамгаалахад тусладаг.</p>
          <div class="flex space-x-4 mt-4">
            <a href="#" class="text-gray-400 hover:text-white"><i class="fab fa-facebook-f"></i></a>
            <a href="#" class="text-gray-400 hover:text-white"><i class="fab fa-twitter"></i></a>
            <a href="#" class="text-gray-400 hover:text-white"><i class="fab fa-linkedin-in"></i></a>
            <a href="#" class="text-gray-400 hover:text-white"><i class="fab fa-instagram"></i></a>
          </div>
        </div>
        <div>
          <h4 class="text-lg font-semibold mb-4">Үйлчилгээ</h4>
          <ul class="space-y-2">
            <li><a href="#" class="text-gray-400 hover:text-white">Хөрөнгө оруулалтын зөвлөгөө</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white">Тэтгэврийн төлөвлөлт</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white">Хөрөнгө оруулалтын зөвлөх үйлчилгээ</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white">Татварын төлөвлөлт</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white">Өв залгамжлалын төлөвлөлт</a></li>
          </ul>
        </div>
        <div>
          <h4 class="text-lg font-semibold mb-4">Компани</h4>
          <ul class="space-y-2">
            <li><a href="#" class="text-gray-400 hover:text-white">Бидний тухай</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white">Манай баг</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white">Ажлын байр</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white">Блог</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white">Холбогдох</a></li>
          </ul>
        </div>
        <div>
          <h4 class="text-lg font-semibold mb-4">Холбогдох</h4>
          <address class="text-gray-400 not-italic">
            <p class="mb-2">Санхүүгийн гудамж 123</p>
            <p class="mb-2">Улаанбаатар хот, Монгол</p>
            <p class="mb-2">Утас: (7011) 12345</p>
            <p class="mb-2">Имэйл: info@primefinance.mn</p>
          </address>
        </div>
      </div>
      <div class="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
        <p>&copy; 2023 PrimeFinance. Бүх эрх хуулиар хамгаалагдсан.</p>
      </div>
    </div>
  </footer>
</template>

<script>
import NavBar from "@/components/bowsys/BowsysNavbar";
import { ref, onMounted } from 'vue';
import Cookies from 'js-cookie';

export default {
  components: { NavBar },
  setup() {
    const mobileMenuOpen = ref(false);
    const isLoggedIn = ref(false);
    
    onMounted(() => {
      // Check if user has token on component mount
      checkUserToken();
    });
    
    const checkUserToken = () => {
      const token = Cookies.get('bowsystoken');
      isLoggedIn.value = !!token; // Convert to boolean
    };
    
    const services = ref([
      {
        icon: 'fas fa-chart-line',
        title: 'Хөрөнгө оруулалтын зөвлөгөө',
        description: 'Мэргэжлийн зөвлөгөө таны хөрөнгө оруулалтын шийдвэр гаргах, портфель өсгөхөд туслах болно.'
      },
      {
        icon: 'fas fa-piggy-bank',
        title: 'Тэтгэврийн төлөвлөлт',
        description: 'Татгалзах амьдралыг тав тухтай, аюулгүй өнгөрүүлэх цогц стратеги.'
      },
      {
        icon: 'fas fa-home',
        title: 'Өв залгамжлалын төлөвлөлт',
        description: 'Хөрөнгөө хамгаалж, ирээдүйн үедээ өвлүүлэхэд туслах.'
      },
      {
        icon: 'fas fa-file-invoice-dollar',
        title: 'Татварын төлөвлөлт',
        description: 'Татварын дарамтыг багасгаж, санхүүгийн үр ашгийг дээшлүүлэх.'
      },
      {
        icon: 'fas fa-shield-alt',
        title: 'Эрсдэлийн удирдлага',
        description: 'Санхүүгийн эрсдлийг тодорхойлж, хөрөнгөө хамгаалах.'
      },
      {
        icon: 'fas fa-hand-holding-usd',
        title: 'Хөрөнгийн удирдлага',
        description: 'Таны хөрөнгийг цогцоор нь удирдах, өсгөх арга зам.'
      }
    ]);
    
    const testimonials = ref([
      {
        name: 'Сараа Жонсон',
        position: 'Гүйцэтгэх захирал, TechStart Inc.',
        comment: 'PrimeFinance манай санхүүгийн стратегийг бүрэн өөрчилсөн. Тэдний мэргэжил хоёр жилийн дотор хөрөнгө оруулалтад 30%-ийн өсөлтийг бий болгоход тусалсан.',
        avatar: 'https://randomuser.me/api/portraits/women/43.jpg'
      },
      {
        name: 'Михаел Чен',
        position: 'Тэтгэвэрт гарсан инженер',
        comment: 'Тэдний тэтгэврийн төлөвлөлтийн ачаар би санхүүгийн санаа зовохгүйгээр алтан наслаж байна. Маш их зөвлөж байна!',
        avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
      },
      {
        name: 'Эмили Родригес',
        position: 'Жижиг бизнес эрхлэгч',
        comment: 'Татварын төлөвлөлтийн үйлчилгээ нь надад хэдэн мянган доллар хэмнэхэд тусалсан. Тэдний баг мэргэжлийн хандлагатай, шуурхай хариу өгдөг.',
        avatar: 'https://randomuser.me/api/portraits/women/65.jpg'
      }
    ]);
    
    return {
      mobileMenuOpen,
      services,
      testimonials,
      isLoggedIn
    }
  }
};
</script>